import { post, get } from '@/utils/http/http'
import {
  HOMEMINIURI,
  FIXUP_URL,
  LIVE_PALY_URL,
  MARKET_URL,
  LIVE_INTERFACE_URL,
  BILL_URL,
  LIVE_GW_URL,
  liveMarketApi,
} from '@/utils/http/baseUrl'
import qs from 'qs'
export default {
  // 获取用户积分数
  GetUserIntegralStatistics: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/userDetail/getUserIntegralStatistics`,
      params,
      false
    ),
  // 获取用户当前月失效积分
  GetUserDeadlineExpiredIntegral: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/userDetail/getUserDeadlineExpiredIntegral`,
      params,
      false
    ),
  // 获取积分商城列表
  GetIntegralActivityList: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/activity/getIntegralActivityList`,
      params,
      false
    ),
  // 获取商品详情
  GetIntegralActivityDetail: params =>
    get(
      `${LIVE_GW_URL}/integral/v1/h5/activity/getIntegralActivityDetail`,
      params,
      false
    ),
  // 兑换商品
  ExchangeAward: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/activity/exchangeAward`,
      params,
      false,
      {
        allResolve: true,
      }
    ),
  // 获取兑换记录列表
  GetExchangeRecordList: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/activity/getExchangeRecordList`,
      params,
      false
    ),
  // 会员升级礼包】【推广员任务奖品】【营销推送奖品】列表
  GetIntegralTaskListByType: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/activity/listAwardRecord`,
      params,
      false
    ),
  // 获取直播用户积分明细
  GetUserIntegralDetatilList: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/userDetail/getUserIntegralDetailList`,
      params,
      false
    ),
  // 获取热门积分商城
  GetHotIntegralActivityList: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/activity/getHotIntegralActivityList`,
      params,
      false
    ),
  // 获取积分任务列表(不用和话题关联的任务)
  GetIntegralTaskList: params =>
    get(
      `${LIVE_GW_URL}/integral/v1/h5/task/getIntegralTaskList`,
      params,
      false
    ),
  // 获取话题积分任务列表
  GetTopicIntegralTaskList: params =>
    get(
      `${LIVE_GW_URL}/integral/v1/h5/basic/getTopicIntegralTaskList`,
      params,
      false
    ),
  // 获取用户资料对应的值
  GetUserDataValue: params =>
    get(`${LIVE_GW_URL}/integral/v1/h5/task/getUserDataValue`, params, false),
  // 更新用户资料对应的值
  UpdateUserDataValue: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/task/updateUserDataValue`,
      params,
      false
    ),
  // 获取验证滑块
  CreateAuthPhoneVerCode: params =>
    post(`/liveajax/CreateAuthPhoneVerCode`, qs.stringify(params), false),
  // 验证滑块
  CheckAuthPhoneVerCodeApi: params =>
    post(`/liveajax/CheckAuthPhoneVerCode`, qs.stringify(params), false, {
      allRes: true,
    }),
  // 获取短信签名
  get_sign: params => post(`${FIXUP_URL}/api/v1/SMS/get_sign`, params, false),
  // 获取验证码
  get_phone_auth_smsode: params =>
    post(`${FIXUP_URL}/api/v1/SMS/get_phone_auth_smsode`, params, false),
  // 校验手机验证码
  PhoneAuth: params => post(`/liveajax/PhoneAuth`, qs.stringify(params), false),
  // 获取积分直播间列表
  GetLiveIntegralList: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/basic/getLiveIntegralList`,
      params,
      false
    ),
  // 获取表单列表
  GetUserData: params =>
    get(`${LIVE_GW_URL}/integral/v1/h5/basic/getUserData`, params, false),
  // 获取积分标题
  GetIntegralBasic: params =>
    get(`${LIVE_GW_URL}/integral/v1/h5/basic/getIntegralBasic`, params, false),
  // 获取签到基础信息
  GetSignedBaseInfo: params =>
    post(`${LIVE_GW_URL}/integral/v1/h5/task/getSignedBaseInfo`, params, false),
  // 获取积分（签到）
  GetIntegral: params =>
    post(`${LIVE_GW_URL}/integral/v1/h5/task/getIntegral`, params, false),
  // 获取签到排行榜
  GetSignInTopRanking: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/task/getSignInTopRanking`,
      params,
      false
    ),
  // 获取任务子项关联话题列表
  GetLiveInteractTopicInfo: params =>
    post(`${HOMEMINIURI}/api/Integral/GetLiveInteractTopicInfo`, params, false),
  // 获取单个任务详情
  GetIntegralTaskAttributeInfo: params =>
    get(
      `${LIVE_GW_URL}/integral/v1/h5/task/getIntegralTaskAttributeInfo`,
      params,
      false
    ),
  // 结算订单
  // penddeal: params => post(`/liveajax/penddeal`, qs.stringify(params), false),
  // 授权手机号
  AllowAuthPhone: params =>
    post(`/liveajax/AllowAuthPhone`, qs.stringify(params), false),

  // 获取第三方积分商城链接
  getIntegralShopLink: data =>
    get(`${LIVE_PALY_URL}/api/live/customlink`, data),
  getAvailableVocherNum: data =>
    post(
      `${MARKET_URL}/api/v1/exchangecoupon/getuserexchangecouponcount`,
      data,
      false
    ),

  // 用户SSO
  isUserSSOLogin: params =>
    post(
      `${LIVE_INTERFACE_URL}/custom/v1/catsso/isUserSSOLogin`,
      params,
      false,
      {
        allResolve: true,
      }
    ),
  // 兑换现金红包
  ExchangeRedPacket: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/activity/exchangeRedPacket`,
      params,
      false,
      {
        allResolve: true,
      }
    ),

  // 获取积分任务的列表
  getIntegralTaskProductList: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/task/getIntegralTaskProductList`,
      params,
      false,
      {
        allResolve: true,
      }
    ),

  // 获取积分页面装修设置
  getPageSettingDetail: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/integralPageSetting/getPageSettingDetail`,
      params,
      false,
      {
        allResolve: true,
      }
    ),

  // 获取积分分类列表
  getActivityClassList: params =>
    get(
      `${LIVE_GW_URL}/integral/v1/h5/activityClass/getActivityClassList`,
      params,
      false,
      {
        allResolve: true,
      }
    ),
}

/** 获取积分变动事件 */
export const GetIntegralTaskTermTypeList = () =>
  get(
    `${LIVE_GW_URL}/integral/v1/admin/integralActivityBasic/getIntegralTaskTermTypeList`,
    {
      zbid: window.zbid,
    }
  )

/**  */
export const isUserThirdLogin = params =>
  post(`${LIVE_INTERFACE_URL}/custom/v1/live/isUserThirdLogin`, params, false, {
    allResolve: true,
    contentType: 'application/json;charset=UTF-8',
  })
/**  */
export const thirdLoginPopSendSms = params =>
  post(
    `${LIVE_INTERFACE_URL}/custom/v1/live/thirdLoginPopSendSms`,
    params,
    false,
    {
      allResolve: true,
      contentType: 'application/json;charset=UTF-8',
    }
  )
/**  */
export const thirdLoginPopVerify = params =>
  post(
    `${LIVE_INTERFACE_URL}/custom/v1/live/thirdLoginPopVerify`,
    params,
    false,
    {
      allResolve: true,
      contentType: 'application/json;charset=UTF-8',
    }
  )

/** 获取账号打通 第三登录弹窗配置 */
export const get_thirdlogib_pop_config = params =>
  get(`${LIVE_PALY_URL}/api/live/get_thirdlogib_pop_config?zbid=${params.zbId}`)

/** 检查直播间是否支持自动提现 */
export const checkAutoWithdrawalSupport = params =>
  post(`${BILL_URL}/CheckAutoWithdrawalSupport`, params, false)

// 积分商城获取兑换记录列表
export const getExchangeRecord = data =>
  post(
    `${LIVE_GW_URL}/health/v1/h5/agent-data/integral/exchangeRecord`,
    data,
    false
  )
// 获取发放待审批记录条数
export const getAuditRecordCount = data =>
  post(`${LIVE_GW_URL}/integral/v1/h5/audit/getAuditRecordCount`, data, false)
// 获取发放积分审批记录列表
export const getAuditRecordList = data =>
  post(`${LIVE_GW_URL}/integral/v1/h5/audit/getAuditRecordList`, data, false)
// 查询积分现金红包
export const queryVerifyInfo = params =>
  post(
    `${LIVE_GW_URL}/integral/v1/h5/activity/queryVerifyInfo`,
    params,
    false,
    {
      allResolve: true,
    }
  )
// 代理查询积分变动记录
export const getUserIntegralDetailList = params =>
  post(
    `${LIVE_GW_URL}/integral/v1/h5/userDetail/agent/getUserIntegralDetailList`,
    params,
    false,
    {
      allResolve: true,
    }
  )
// 微信端获取分享语
export const getShareTipSetting = params =>
  post(
    `${MARKET_URL}/api/v1/public/sharecard/get_sharetip_setting`,
    params,
    false,
    {
      allResolve: true,
    }
  )

// 微信端获取分享卡列表
export const getShareCardList = params =>
  get(
    `${MARKET_URL}/api/v1/public/sharecard/get_sharecard_list`,
    params,
    false,
    {
      allResolve: true,
    }
  )
